<template>
    <div>
        <TeamTrainingPopupFrame :isListModal="isListModal" :modalScrollTop="scrollTop" :changeOverflow="changeOverflow" :changeHeight="80" :changeBottom="0" :isModalBackTransparent="isModalBackTransparent" :openModal="openModal" :isOpen="isOpenSoccerTeamListModal" :closeCompleteAction="closeSoccerTeamListModal">
            <div @touchstart="touchstart" @touchend="touchend" style="">
                <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            </div>
            <div @scroll="detectScroll($event)" ref="scroll_wrapper" style="flex: 1; overscroll-behavior: none; margin-top: 12px;">
                <div style="margin-bottom: 52px; padding-bottom: 32px;">
                    <!-- TODO 임시로 주석 처리 후에 안쓰면 삭제할것-->
                    <template v-if="false">
                        <div style="font-weight: 700; font-size: 20px; line-height: 24px; padding: 0 12px; ">감터뷰 🎥</div>
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 12px; ">
                            <div style="line-height: 24px; font-size: 14px; color: #606060;">다양한 축구팀의 감독 인터뷰를 만나보세요</div>
                            <div @click="showSpotLightList" style="font-weight: 700; font-size: 14px; display: flex; align-items: center; gap: 4px; ">
                                <div>더보기</div>
                                <img style="width: 10px;" :src="require('@/assets/img/right_arrow.png')" alt="">
                            </div>
                        </div>
                        <div style="margin-top: 12px; padding: 0 12px; padding-bottom: 32px;">
                            <swiper style="height: 220px; border-radius: 12px; overflow: hidden; box-shadow: 0px 5px 10px 0px #210F034D;" :options="swiperOption" role="tablist" ref="swiper">
                                <swiper-slide v-for="each, i in teamListData.spotlights" :key="i + 'training'" style="width: 100%; height: 100%; position: relative; border-radius: 12px; background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%);" role="tab">
                                    <img style="width: 100%; height: 100%; position: absolute; z-index: -1; object-fit: cover;" :src="$resourcePath + each.image_path" alt="">
                                    <div @click="showInterviewDetail(each, i)" style="position: relative; padding: 20px; height: 100%; display: flex; flex-direction: column; z-index: 1; justify-content: end;">
                                        <div style="color: #fff; font-size: 20px; font-weight: 700; line-height: 32px; margin-bottom: 4px; word-break: break-all;">{{ each.title }}</div>
                                        <div style="color: #bbb; font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.name }}</div>
                                    </div>
                                </swiper-slide>
                                <div key="test" class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; top: 20px; height: 20px; text-align: right; padding-right: 20px; z-index: 10; display:inline-block;"></div>
                            </swiper>
                        </div>
                    </template>

                    <div style="height:10px;"></div>

                    <div style="margin-bottom: 8px; padding-left: 12px; font-size: 14px; font-weight: 700;">전국 모든 축구팀🏟️</div>
                    <div style="margin-top: 20px; display: flex; padding: 0 12px; gap: 8px; padding-bottom: 18px; ">
                        <div @click="showPopupMenuModal(each.key, i); $Util.sendEventClick(`축구팀찾기_지도_옵션설정_${each.name}`, true)" v-for="each, i in sortBtnList" :key="i + 'sort'" :style="{ border: sortBtnKeys[each.key] === each.key ? '2px solid #210f03' : '1px solid #d9d9d9' }" style="padding: 8px 12px; display: flex; gap: 4px; align-items: center; font-weight: 700; font-size: 14px; border-radius: 50px; border: 2px solid #210f03;">
                            <div style="line-height: 24px; ">{{ each.name }}</div>
                            <img style="width: 6px; transform: rotate(90deg);" :src="require('@/assets/img/right_arrow.png')" alt="">
                        </div>
                    </div>
                    <div @click="showSoccerTeamDetail(each);" v-for="each, i in teamListData.teams" :key="i + 'teamList'">
                        <InteractionOfElementBackgroundColor style="display: flex; align-items: center; padding: 26px 12px; gap: 16px; border-bottom: 1px solid #ebebeb" originColor="#fff" changeColor="#F5F5F5">
                            <div style="width: 80px;">
                                <img style="width: 80px;" :src="$resourcePath + each.image_path" alt="">
                            </div>
                            <div>
                                <div style="font-weight: 700; line-height: 24px; margin-bottom: 8px;">{{ each.name }}</div>
                                <div style="display: flex; gap: 4px; margin-bottom: 4px; overflow-x: scroll;" class="hide_scroll">
                                    <div v-if="each.manager" style="background-color: #ebebeb; display: flex; flex-shrink: 0; align-items: center; gap: 4px; border-radius: 4px; padding: 5px; line-height: 20px; font-weight: 700; font-size: 12px;">
                                        <div>{{ each.manager ? each.manager.nic_name : '' }}</div>
                                        <img v-if="each.type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                    <div v-if="each.type" style="background-color: #ebebeb; display: flex; flex-shrink: 0; align-items: center; gap: 4px; border-radius: 4px; padding: 5px; line-height: 20px; font-weight: 700; font-size: 12px;">
                                        <div>{{ each.type }}</div>
                                    </div>
                                    <div v-if="each.place" style="background-color: #ebebeb; display: flex; flex-shrink: 0; align-items: center; gap: 4px; border-radius: 4px; padding: 5px; line-height: 20px; font-weight: 700; font-size: 12px;">
                                        <div>{{ each.place ? each.place.name : '' }}</div>
                                    </div>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <img :src="require('@/assets/img/team_star.svg')" alt="">
                                    <div style="font-weight: 700; font-size: 14px;">{{ each.like_cnt }}</div>
                                </div>
                            </div>
                        </InteractionOfElementBackgroundColor>
                    </div>
                </div>
            </div>
        </TeamTrainingPopupFrame>
        <div style="position: relative; z-index: 1000;">
            <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        </div>
    </div>
</template>

<script>
import TeamTrainingPopupFrame from '@/components/common/TeamTrainingPopupFrame'
import { CLASS_TYPE, TEAM_TYPE } from '@/Constants'
import { JOIN_STATE } from "@/Constants";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import InteractionOfElementBackgroundColor from '@/components/common/InteractionOfElementBackgroundColor';
import BottomPopupMenu from '@/components/common/BottomPopupMenu'

export default {
    name: 'SoccerTeamListModal',
    components: { TeamTrainingPopupFrame, BottomPopupMenu, swiper, swiperSlide, InteractionOfElementBackgroundColor },
    props: {
        isOpenSoccerTeamListModal: {
            type: Boolean,
            default: false,
        },
        closeSoccerTeamListModal: {
            type: Function,
            default: () => { },
        },
        memberIdx: {
            type: [Number, String],
            default: -1
        },
        placeId: {
            type: [Number, String],
            default: null
        },
        openModal: {
            type: Function,
            default: () => { }
        },
        isModalBackTransparent: {
            type: Boolean,
            default: true,
        },
        isListModal: {
            type: Boolean,
            default: true
        },
        teamListData: {
            type: Object,
            default: () => { }
        },
        setSortCondition: {
            type: Function,
            default: () => {}
        },
        showPopupMenuModal: {
            type: Function,
            default: () => {}
        },
        sortBtnList: {
            type: Array,
            default: () => {}
        },
        sortBtnKeys: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            TEAM_TYPE: TEAM_TYPE,
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                autoplay: {
                    delay: 5000
                },
                curIndex: 0,
            },
            JOIN_STATE: JOIN_STATE,
            selectedDay: null,
            // days: ["월", "화", "수", "목", "금", "토", "일"],
            CLASS_TYPE: CLASS_TYPE,
            isShowNowFeedBack: false,
            stopClock: false,
            isStopEvent: false,
            scrollTop: 0,
            spotlights: [],
            teamList: [],
            isShowPopMenu: false,
            menuOptions: {}
        };
    },
    created() {
        // this.getMainData()
        // this.getTeamList()
    },
    methods: {
        showSoccerTeamDetail(teamInfo) {
            const isFromHome = this.$route.query.is_from_home ? JSON.parse(this.$route.query.is_from_home) : false
            if (isFromHome) {
                this.$Util.sendEventClick('홈=>축구팀입단_팀_자세히보기', true)
            } else {
                this.$Util.sendEventClick('지도_트레이닝자세히보기', true)
            }
            this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: teamInfo.idx })
            // this.$Util.checkAppLinkPageShow();
        },
        showSpotLightList() {
            const isFromHome = this.$route.query.is_from_home ? JSON.parse(this.$route.query.is_from_home) : false
            if (isFromHome) {
                this.$Util.sendEventClick('홈=>축구팀입단_감터뷰_더보기', true)
            } else {
                this.$Util.sendEventClick('축구팀찾기_감터뷰_더보기', true)
            }
            this.$GlobalStore.addModal('SpotLightList',)
            // this.$Util.checkAppLinkPageShow();
        },
        showInterviewDetail(detail) {
            this.$Util.sendEventClick('감터뷰_영상배너_클릭', true)
            this.$GlobalStore.addModal('InterviewDetail', { spotlightIdx: detail.idx })
            // this.$Util.checkAppLinkPageShow();
        },
        touchstart() {
            this.scrollTop = 0
        },
        touchend() {
            this.scrollTop = 0
        },
        detectScroll(e) {
            this.scrollTop = e.target.scrollTop
        },
        changeOverflow(isHidden) {
            this.$nextTick(() => {
                if (isHidden) {
                    this.$refs.scroll_wrapper.scrollTop = 0
                    this.$refs.scroll_wrapper.style.overflowY = ''
                } else {
                    this.$refs.scroll_wrapper.style.overflowY = 'scroll'
                }
            })
        },
        isGif(imagePath) {
            return imagePath.endsWith('.gif')
        },
        showSchedule(idx) {
            this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: idx })
            // this.$Util.checkAppLinkPageShow();
        },
        closeNowFeedBack() {
            this.isShowNowFeedBack = false
        },
        transDateHangul(schedule) {
            const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
            if (schedule.repeat_schedule.days !== '') {
                return schedule.repeat_schedule.days.split(',').map(day => `매주 ${weekdays[parseInt(day)]}요일`).join(', ')
            } else {
                return this.$Util.getMMDDDayHangulStr(schedule.join_schedules[0].join_begin_date_time).replace(/^\d+년\s*/, '');
            }
        },
        transDate(date) {
            if (date.split(' ')[0] === this.today) {
                return ''
            } else {
                const transDate = this.$Util.getMMDDDayHangulStr(date).split(' ')
                transDate.splice(0, 1)

                return transDate.join(' ')
            }

        },
        selectDay(day) {
            if (this.selectedDay === day) {
                this.selectedDay = null;
            } else {
                this.selectedDay = day;
            }
        }
    },
    watch: {
        isOpenSoccerTeamListModal(newVal) {
            if (newVal) {
                this.changeOverflow(false)
                // this.getMainData()
            } else {
                // this.schedules = []
                this.isShowNowFeedBack = false
            }
        }
    }
}
</script>

<style scoped>
.active {
    padding: 12px 16px;
    border-radius: 12px;
    background-color: #210f03;
    color: #fff;
    font-size: 14px;
    line-height: 24px;
}

.un_active {
    padding: 12px 16px;
    border-radius: 12px;
    background-color: #f5f5f5;
    font-size: 14px;
    line-height: 24px;
}

.is_join {
    position: absolute;
    width: 90px;
    height: 28px;
    border-radius: 12px;
    background: #210F03E5;
    border: 1px solid #FFFFFF99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 12px;
    right: 12px;
    color: #fff;
}

.end_now {
    position: absolute;
    width: 69px;
    height: 28px;
    border-radius: 12px;
    background: #210F0366;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 12px;
    right: 12px;
    color: #fff;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}
</style>